import { getCustomFormConfig } from '../co2_custom/getCustomFormConfig';
// import { IDs } from '../../../helpers/IDs';

export function isFieldHidden(entity: string, key: string, data: any, dataGlobal: any): boolean {
    data = data || {};
    const config: any = getCustomFormConfig(entity, data, dataGlobal);
    const isHidden: boolean = (config[key] || {}).hidden === true || (config[key] || {}).hidden_input === true;
    /*
    switch (entity) {
        case IDs.ENT_CO2_SCOPE3_ABFALL:
            if (
                (key === 'menge' && data.kategorie === 'gemischt')
                || (['leerungen', 'volumen_tonne'].indexOf(key) !== -1 && data.kategorie !== 'gemischt')
            ) {
                isHidden = true;
            }
            break;
        case IDs.ENT_CO2_SCOPE3_REISEN:
            if (
                (['entfernung', 'teilstrecken'].indexOf(key) !== -1 && +data.firmenfahrzeug === 1)
                || (key === 'uebernachtungen_anzahl'
                    && (data.uebernachtungen === null || data.uebernachtungen === '' || +data.uebernachtungen_orig === 2 || +data.uebernachtungen === 2)
                )
                || (key === 'teilnehmer' && (
                    (data.uebernachtungen === null || data.uebernachtungen === '' || +data.uebernachtungen_orig === 2
                    || +data.uebernachtungen === 2) || (+data.uebernachtungen_anzahl || 0) === 0
                ))
            ) {
                isHidden = true;
            }
            break;
    }*/

    return isHidden;
}
